import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpService } from 'src/app/http.service';
import { PreferenceService } from 'src/app/preference.service';
import { AdminReportDetailComponent } from '../admin-report-detail/admin-report-detail.component';
import { ClipboardService } from 'ngx-clipboard';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent {

  public is_loading = false;
  public is_load = false;
  public disabled_pagenat = false;
  public setting: any = [];
  public configuration: any = {};
  public content: any = [];
  public current_page = 1;
  public total_page = 10;
  public page_array = [];
  public no_per_page: any = 20;
  public show_sum = false;
  public summary: any = null;
  public pagenat: any = null;
  public hiddenColumns: string[] = [];
  public showColumnSelector = false;
  public error = '';
  private requestId = 0;
  // Optional override so a page hosting >1 table can give each a distinct
  // preference bucket. Defaults to the route path (one bucket per function).
  @Input() columnPrefKey: string = '';
  private config: any;
  private url;
  private post_data;
  public is_mario: boolean = false;

  get visibleSetting(): any[] {
    if (!this.setting) return [];
    return this.setting.filter((h: any) => !this.hiddenColumns.includes(h.label));
  }

  toggleColumnSelector() {
    this.showColumnSelector = !this.showColumnSelector;
  }

  toggleColumn(label: string) {
    const idx = this.hiddenColumns.indexOf(label);
    if (idx >= 0) {
      this.hiddenColumns = this.hiddenColumns.filter(l => l !== label);
    } else {
      if (this.visibleSetting.length <= 1) return;
      this.hiddenColumns = [...this.hiddenColumns, label];
    }
    this.pref.set(this.columnScope(), this.hiddenColumns);
  }

  linkQueryParams(field: any, row: any): any {
    if (!field || !field.query_key || !field.key) return null;
    return { [field.query_key]: row[field.key] };
  }

  // Stable per-function key. Route looks like /lo/<company_uuid>/<path...>;
  // strip 'lo' + company so the same report shares one preference across
  // companies (the columns are identical regardless of company).
  private columnScope(): string {
    if (this.columnPrefKey) return 'cols::' + this.columnPrefKey;
    let url = '';
    try { url = (this.router.url || '').split('?')[0]; } catch { url = ''; }
    const parts = url.split('/').filter(Boolean); // [lo, <uuid>, ...path]
    const path = parts.slice(2).join('/') || url || 'default';
    return 'cols::' + path;
  }

  private loadColumnPrefs() {
    const saved = this.pref.get<string[]>(this.columnScope(), []);
    if (Array.isArray(saved) && saved.length && this.setting) {
      // only honour labels that still exist, so a renamed/removed column
      // can never permanently hide everything
      const valid = this.setting.map((f: any) => f && f.label).filter(Boolean);
      this.hiddenColumns = saved.filter((l: string) => valid.includes(l));
      if (valid.length && this.visibleSetting.length === 0) {
        this.hiddenColumns = [];
        this.pref.set(this.columnScope(), []);
      }
    } else {
      this.hiddenColumns = [];
    }
  }

  @Output() reloadEvent = new EventEmitter();
  @Output() dataEvent = new EventEmitter();

  constructor(private http: HttpService, public ngbModal: NgbModal, private clipboardApi: ClipboardService, private pref: PreferenceService, private router: Router) {
    let access: any = this.http.getAccess();

    if (access.is_mario) {
      this.is_mario = access.is_mario == "1" ? true : false;
    }

    this.getConfiguration();
  }

  @Input() set setSetting(v: any) {
    this.config = v
    this.init(v);
  }

  private build_page_array() {
    this.total_page;
    const differences = 3;
    if (this.current_page < differences) {

    }
  }

  public async init(setting) {

    if (this.config != setting) {
      this.current_page = 1;
    }

    this.hiddenColumns = [];
    this.showColumnSelector = false;
    this.config = setting;
    this.is_loading = true;
    this.content = [];

    this.setting = setting.fields;
    this.loadColumnPrefs();
    this.show_sum = setting.show_sum;
    if (setting.disabled_pagenat) {
      this.disabled_pagenat = setting.disabled_pagenat;
    }

    if (setting.no_per_page) {
      this.no_per_page = setting.no_per_page;
    }

    if (setting.post.url) {
      this.url = setting.post.url;
    }

    if (setting.post.data) {
      this.post_data = setting.post.data;
    }

    if (setting.filter) {
      this.post_data.filter = setting.filter
    }

    await this.load();
  }

  public async getConfiguration() {
    let rtn: any = await this.http.post("/admin/company/setting");
    this.configuration = rtn?.setting || {};
  }

  public async reload(data = null, page = 0, no_per_page = null) {

    if (no_per_page) {
      this.no_per_page = no_per_page;
    }

    if (data) {
      this.post_data = data;
    }

  }

  private async load() {
    const requestId = ++this.requestId;
    const data = { ...this.post_data };

    data['number'] = this.no_per_page ? this.no_per_page : 20;
    data['page'] = this.current_page ? this.current_page : 1;

    this.is_loading = true;
    this.error = '';
    this.content = [];
    this.summary = null;
    this.pagenat = null;
    try {
      const reply: any = await this.http.post(this.url, data);
      if (requestId !== this.requestId) return;
      const rows = Array.isArray(reply) ? reply : reply?.collection;
      if (reply?.status === false || !Array.isArray(rows) || rows.some(row => !row || typeof row !== 'object')) {
        throw new Error(reply?.message || 'Unable to load records. Please retry.');
      }
      this.content = rows;
      if (reply.pagenat) {
        this.summary = reply.summary;
        this.pagenat = reply.pagenat;
        this.current_page = reply.pagenat.current;
        this.total_page = Math.ceil(reply.pagenat.total / reply.pagenat.per_page);
      }
      this.dataEvent.emit(reply);
    } catch (error: any) {
      if (requestId !== this.requestId) return;
      this.error = error?.message || 'Unable to load records. Please retry.';
    } finally {
      if (requestId === this.requestId) this.is_loading = false;
    }
  }

  public async setPage(page) {
    this.current_page = page;
    await this.load();
  }

  public async setPageSize(size) {
    this.no_per_page = size;
    this.current_page = 1;
    this.init(this.config);
  }

  public async delete(title, table, uuid) {
    var message = confirm("You are about to remove " + title + " from the record. This is not revisable. Are you sure?")

    if (message) {
      await this.http.post("/admin/setting/remove/update", { title, table, uuid });
      await this.load();
    }
  }

  public async claim(data: any) {
    await this.http.post("/admin/expenses/claim", data);

    data.claim = data.claim ? false : true

    this.reloadEvent.emit(true)
  }

  public async copy(data) {
    await this.http.post("/admin/copy", { data: [data] });
    alert("Data Copied!")
  }

  public async reset() {
    this.content = [];
  }

  public sum(key) {
    var result = this.content.map(a => a[key]);

    result = result.filter(n => n);

    if (result.length == 0) {
      return 0;
    }

    const total = result.reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
    return total
  }

  public parseFloat(v: any) {
    return parseFloat(v)
  }

  public displayValue(row: any, field: any) {
    const value = row ? row[field.key] : null;
    if (value !== undefined && value !== null && value !== '') {
      if (field.format === 'date') {
        return this.formatDateOnly(value);
      }
      return value;
    }

    if (!field.fallback_keys || !row) {
      return value;
    }

    for (const key of field.fallback_keys) {
      const fallback = row[key];
      if (fallback !== undefined && fallback !== null && fallback !== '') {
        if (field.format === 'date') {
          return this.formatDateOnly(fallback);
        }
        return fallback;
      }
    }

    return value;
  }

  private formatDateOnly(value: any) {
    if (!value) return '';
    if (value instanceof Date && !isNaN(value.getTime())) {
      return this.formatBusinessDate(value);
    }

    const text = String(value);
    const displayMatch = text.match(/^(\d{2})-(\d{2})-(\d{4})$/);
    if (displayMatch) {
      return text;
    }

    const isoMatch = text.match(/^(\d{4})-(\d{2})-(\d{2})T/);
    if (isoMatch) {
      const parsed = new Date(text);
      if (!isNaN(parsed.getTime())) {
        return this.formatBusinessDate(parsed);
      }
    }

    const match = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (match) {
      return `${match[3]}-${match[2]}-${match[1]}`;
    }

    const parsed = new Date(value);
    if (!isNaN(parsed.getTime())) {
      return this.formatBusinessDate(parsed);
    }

    return text;
  }

  private formatBusinessDate(value: Date) {
    const businessDate = new Date(value.getTime() + (8 * 60 * 60 * 1000));
    const day = String(businessDate.getUTCDate()).padStart(2, '0');
    const month = String(businessDate.getUTCMonth() + 1).padStart(2, '0');
    return `${day}-${month}-${businessDate.getUTCFullYear()}`;
  }

  public checkedValue() {
    return this.content.filter((v: any) => {
      return v.checked
    })
  }

  openReport(h: any, c: any) {
    let modal = this.ngbModal.open(AdminReportDetailComponent, { size: "md" });
    modal.componentInstance.setIDS = c.ids
    modal.componentInstance.type = c.type;
  }

  copyFunction(str: string) {
    this.clipboardApi.copyFromContent(str)
    alert("Copied. " + str)
  }
}
